<template>
  <div
      v-if="panel"
      class="cp-gradient-bar">
    <div
        :style="getGradientStyle"
        class="cp-gradient-bar__fill"/>
    <div class="cp-gradient-bar__track">
      <div
          v-for="point in getPoints"
          :key="point.id"
          :class="{ 'is-selected': selectedPoint && point.id === selectedPoint.id }"
          :style="{ left: `${point.position}%`, background: point.rgba }"
          class="cp-gradient-bar__stop"
          @mousedown.stop.prevent="startDrag(point)"
      />
    </div>
  </div>
  <div
      v-else
      class="mb-15">
    <div
        :style="getGradientStyle"
        class="bar"
        @click="addPoint($event)">
      <div
          v-for="point in getPoints"
          :key="point.id"
          :class="selectedPoint && point.id === selectedPoint.id ? 'selected-point' : ''"
          :style="{ left: `${point.position}%` }"
          class="point"
          @mousedown.stop.prevent="startDrag(point)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeObject: {
      type:    Object,
      default: {},
    },
    color: {
      type:    String,
      default: '',
    },
    panel: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDragging:    false,
      selectedPoint: null,
      barWidth:      0,
    };
  },
  computed: {
    getGradientStyle() {
      if (this.panel) {
        return { background: this.getGradientString(this.activeObject.gradient.colors) };
      }
      const style = {
        marginTop:  '10px',
        background: this.getGradientString(this.activeObject.gradient.colors),
      };
      return style;
    },
    getPoints() {
      return this.activeObject.gradient.colors.slice().sort((a, b) => Number(a.position) - Number(b.position));
    },
  },
  beforeMount() {
    this.selectedPoint = this.activeObject.gradient.colors.find(point => point.isSelected);
  },
  methods: {
    getGradientString(colors) {
      const gradientStops = [...colors]
          .sort((a, b) => Number(a.position) - Number(b.position))
          .map(color => `${color.rgba} ${color.position}%`)
          .join(', ');
      return `linear-gradient(90deg, ${gradientStops})`;
    },
    addPoint(event) {
      if (this.isDragging) {
        this.isDragging = false;
        return;
      }
      this.barWidth            = event.currentTarget.offsetWidth;
      const clickPosition      = event.offsetX;
      const positionPercentage = (clickPosition / this.barWidth) * 100;

      /* this.pointArray.push({
        position: positionPercentage.toFixed(2),
        color: 'blue',
      }); */
    },
    startDrag(point) {
      const originalIndex = this.activeObject.gradient.colors.findIndex(color => color.id === point.id);
      if (originalIndex !== -1) {
        this.$emit('updateSelectedPointOfGradient', originalIndex);
      }
      this.selectedPoint = point;
      this.isDragging    = true;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(event) {
      if (!this.selectedPoint) { return; }
      const bar     = this.$el.querySelector(this.panel ? '.cp-gradient-bar__track' : '.bar');
      if (!bar) { return; }
      const barRect = bar.getBoundingClientRect();

      const mousePosition = event.clientX - barRect.left;
      let newPosition     = (mousePosition / barRect.width) * 100;

      if (newPosition < 0) { newPosition = 0; }
      if (newPosition > 100) { newPosition = 100; }

      this.selectedPoint.position = Number(newPosition.toFixed(2));
      this.$emit('updateSelectedPointPosition', this.selectedPoint.position);
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.drag);
    document.removeEventListener('mouseup', this.stopDrag);
  },
};
</script>

<style scoped lang="scss">
@import '../../LeftSection/styles/lp-tokens';

.cp-gradient-bar {
  position: relative;
  height: 24px;
}

.cp-gradient-bar__fill {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: $lp-radius-control;
  box-shadow: inset 0 0 0 1px rgba(20, 22, 27, 0.08);
}

.cp-gradient-bar__track {
  position: absolute;
  top: 0;
  right: 12px;
  bottom: 0;
  left: 12px;
}

.cp-gradient-bar__stop {
  position: absolute;
  top: 50%;
  width: 20px;
  height: 20px;
  border: 2px solid $white;
  border-radius: 6px;
  box-shadow: 0 0 0 1px rgba(20, 22, 27, 0.28), 0 1px 3px rgba(20, 22, 27, 0.25);
  transform: translate(-50%, -50%);
  cursor: pointer;

  &:active {
    cursor: grabbing;
  }

  &.is-selected {
    z-index: 1;
    box-shadow: 0 0 0 2px $lp-accent, 0 1px 3px rgba(20, 22, 27, 0.25);
  }
}

.bar {
  position: relative;
  width: 100%;
  height: 24px;
  background-color: lightgray;
  border-radius: 4px;
}

.point {
  position: absolute;
  width: 6px;
  height: 34px;
  border: 1px solid black;
  border-radius: 4px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.selected-point {
  background: black;
}
</style>
